module.exports = __webpack_public_path__ + "components/outside-promo-page/static/bottompanel-80ba99769963ea30ef948584d8cc6801.webp";